export default __webpack_public_path__ + "static/media/mulhersentada.afe65585.jpg";